var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 373.7 168.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:33.32px;font-family:Poppins-Regular, Poppins;}.cls-3{fill:#fdd135;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-dark1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "287.49 47.66 258.5 18.67 227.97 47.36 222.02 41.03 258.69 6.57 293.64 41.52 287.49 47.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.74,36.33V108.5H64.25V54.69l-24,53.81H33.59L9.49,54.58V108.5H0V36.33H10.22L36.92,96l26.7-59.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.8,64.33a25.68,25.68,0,0,1,9.75-10.27,26.78,26.78,0,0,1,13.82-3.65,25.43,25.43,0,0,1,13,3.23,21.55,21.55,0,0,1,8.24,8.14V51.35h9.59V108.5h-9.59V97.86a22.3,22.3,0,0,1-8.4,8.29,25.12,25.12,0,0,1-13,3.29,25.84,25.84,0,0,1-13.77-3.76,26.29,26.29,0,0,1-9.7-10.53,32.83,32.83,0,0,1-3.54-15.43A32.19,32.19,0,0,1,89.8,64.33ZM132,68.55a18.48,18.48,0,0,0-7-7.35,20,20,0,0,0-19.45-.05,18.17,18.17,0,0,0-7,7.3A23.22,23.22,0,0,0,96,79.72a23.77,23.77,0,0,0,2.61,11.42,18.45,18.45,0,0,0,7,7.4,18.83,18.83,0,0,0,9.7,2.56A19.14,19.14,0,0,0,125,98.54a18.3,18.3,0,0,0,7-7.4,23.56,23.56,0,0,0,2.61-11.32A23.25,23.25,0,0,0,132,68.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.05,56.61q6.47,6.31,6.46,18.2V108.5h-9.38V76.17q0-8.55-4.28-13.09t-11.68-4.54c-5,0-9,1.57-11.94,4.7s-4.43,7.68-4.43,13.66v31.6h-9.5V51.35h9.5v8.13a18.81,18.81,0,0,1,7.66-6.78,23.79,23.79,0,0,1,10.69-2.39Q198.58,50.31,205.05,56.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 227.05,
    y: 51.35,
    width: 9.49,
    height: 57.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.45,56.61q6.46,6.31,6.47,18.2V108.5h-9.39V76.17q0-8.55-4.27-13.09t-11.68-4.54q-7.51,0-11.95,4.7T262.2,76.9v31.6h-9.49V51.35h9.49v8.13a18.84,18.84,0,0,1,7.67-6.78,23.73,23.73,0,0,1,10.69-2.39Q291,50.31,297.45,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.84,105.79a26,26,0,0,1-10.22-10.38,31.78,31.78,0,0,1-3.7-15.59,31,31,0,0,1,3.8-15.49A26.21,26.21,0,0,1,330.1,54a31.83,31.83,0,0,1,29.41,0,26.28,26.28,0,0,1,10.38,10.27,30.8,30.8,0,0,1,3.81,15.54,30.41,30.41,0,0,1-3.92,15.59,27,27,0,0,1-10.58,10.38,30.29,30.29,0,0,1-14.81,3.65A29.16,29.16,0,0,1,329.84,105.79ZM354,98.7a18.24,18.24,0,0,0,7.25-7.2A23,23,0,0,0,364,79.82a23.38,23.38,0,0,0-2.72-11.68A17.66,17.66,0,0,0,354.19,61a20.44,20.44,0,0,0-19,0,17.15,17.15,0,0,0-6.94,7.14,24.15,24.15,0,0,0-2.61,11.68,24.88,24.88,0,0,0,2.56,11.79A17,17,0,0,0,335,98.75a19.13,19.13,0,0,0,9.39,2.35A20,20,0,0,0,354,98.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 253.03,
    y: 34.7,
    width: 9.25,
    height: 9.25
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(64.59 149.31)"
  }, "at your service"), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.36,11.26a12.9,12.9,0,0,1-9.43,9.49,12.93,12.93,0,0,1,9.41,9.42,12.94,12.94,0,0,1,9.34-9.4A12.93,12.93,0,0,1,219.36,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.84,0a9,9,0,0,1-6.55,6.6,9,9,0,0,1,6.54,6.54,9,9,0,0,1,6.49-6.53A9,9,0,0,1,231.84,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark1);
export default __webpack_public_path__ + "static/media/logo-dark1.a9d9a4696aa48309e3ae85a412167bfb.svg";
export { ForwardRef as ReactComponent };